module.exports = __webpack_public_path__ + "static/media/institute-20-min.d7aa3124.webp";